exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-box[data-v-72de42f2]{display:flex;flex-direction:row;position:relative}.label-box:hover .operate[data-v-72de42f2]{display:block;color:#409eff}.label-box .operate-add-row[data-v-72de42f2]{position:absolute;bottom:-15px;left:50%;margin-left:-5px}.label-box .operate-add-column[data-v-72de42f2]{position:absolute;right:-10px}.operate[data-v-72de42f2]{display:none}.edit-label[data-v-72de42f2]{flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-72de42f2","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TableHeaderBox/TableHeaderBox.vue
// module id = 111
// module chunks = 0